export default "__VITE_ASSET__B2IX2lpw__"